import {scrollButton} from "./scrollButton";
import {carousel} from "./carousel";
import "./readMore";
import {burgerMenu} from "./burgerMenu";
import {toggleMap} from "./toggleMap";



scrollButton.init();
carousel.init();
burgerMenu.init();
toggleMap.init();